var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIaqualink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.0348 11.8435.2087 1.7217c1.2174-1.5652 4.9669-4.69564 10.2261-4.69564 5.2591 0 8.3826 2.81744 9.2869 4.22604l.2087-1.8782c-.9913-1.46088-4.2782-4.38262-9.4956-4.38262s-9.1305 3.33912-10.4348 5.00872zm2.5565 4.1739-.2609-1.3044c1.0783-1.2695 4.2157-3.8087 8.1392-3.8087s6.4348 2.2609 7.2 3.3913l-.3131 1.3044c-.5739-1.0609-2.7548-3.1826-6.8869-3.1826-4.1322 0-6.9739 2.4-7.8783 3.6zm2.2957.8348.1565 1.2521c.6261-.7652 2.5878-2.2956 5.4261-2.2956 2.3478 0 4.1391 1.4261 4.4348 2.1391l.2087-1.4087c-.5392-.7478-2.2227-2.2435-4.6435-2.2435-3.1082 0-4.4925 1.4317-5.3581 2.3268l-.0001.0001-.0003.0003-.0002.0003c-.0787.0813-.153.1581-.2239.2291zm-3.6522 19.8261 3.9652-11.1131h4.6957l-3.8087 10.1739c-.4696 1.4087-.4383 2.9739 1.3565 2.9739 1.5632 0 2.7386-1.0291 3.2916-1.7428.1166-.1504.3353-.1898.4855-.073.1116.0868.155.2361.0841.3584-.8115 1.3995-4.493 3.9096-6.5743 3.9096-4.0904 0-4.0347-2.9913-3.4956-4.4869zm5.0191-15.1096c-.001 1.4129.8254 2.2362 2.2372 2.2268v-.0011c1.9973-.0135 3.5218-1.9784 3.0376-3.9161-.2087-.8338-.9297-1.4171-1.7833-1.5225-2.015-.2473-3.4904 1.4358-3.4915 3.2129z",
    fill: "#36445b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaqualink);
export default __webpack_public_path__ + "static/media/iaqualink.a77b745fe97894d02267d12eb3dc0f25.svg";
export { ForwardRef as ReactComponent };